<template>
  <div class="container">
    <div class="title">{{ title }}</div>
    <div class="content" v-html="content"></div>
  </div>
</template>

<script>
import { getArticle } from './http.js'
import { GetQueryString } from '../../utils.js'
export default {
  data() {
    return {
      title: '',
      content: ''
    }
  },
  mounted() {
    let language = GetQueryString('language') || window.navigator.language
    let url = process.env.NODE_ENV === 'development' ? '/proxy-api/scanner_api/protocol/privacy_policy' : '/scanner_api/protocol/privacy_policy'
    getArticle(
      url,
      {language},
      res => {
        console.log(res.data.payload)
        let data = res.data.payload.article
        this.title = data.title
        document.title = data.title
        this.content = data.content
      },
      () => {}
    )
  }
}
</script>

<style scoped>
.container {
  padding: 0.2rem 0.15rem;
  overflow-x: hidden;
  word-break: break-all;
  white-space: pre-line!important
}
.title {
  font-size: 0.4rem;
  text-align: center;
}
.content {
  font-size: 0.2rem;
  margin-top: 0.2rem;
  line-height: 1.5;
}
</style>



// WEBPACK FOOTER //
// src/views/rich-privacypolicy/index.vue